/**
 * Cohort triangle. Immature cells stay an em dash; heat is the resolved share.
 */
import { renderDataTable } from './data-table.js';
import { cellText, resolvedOf } from './shape.js';

function dayCell(cell) {
  if (cell && typeof cell === 'object') return cell;
  return { text: cell == null ? '' : String(cell) };
}

/**
 * @param {object} block
 * @param {{ onAsk?: Function }} [actions]
 * @returns {HTMLElement}
 */
export function renderCohort(block, actions) {
  const data = resolvedOf(block);
  const days = Array.isArray(data.days) ? data.days.map(String) : [];
  const columns = [
    { key: 'cohort', label: 'Cohort', width: 'wide', wrap: true },
    { key: 'size', label: 'Size', format: 'number' },
    ...days.map((day, index) => ({ key: `d${index}`, label: day, format: 'percent' })),
  ];
  const rows = (Array.isArray(data.rows) ? data.rows : []).map((row) => {
    const record = {
      cohort: row.cohort && typeof row.cohort === 'object' ? row.cohort : { text: cellText(row.cohort), raw: row.raw },
      size: row.size && typeof row.size === 'object' ? row.size : { text: cellText(row.size), value: row.size },
    };
    days.forEach((_, index) => {
      record[`d${index}`] = dayCell((row.cells || [])[index]);
    });
    return record;
  });
  let totals = null;
  if (data.average) {
    const cells = { size: data.average.size || '' };
    days.forEach((_, index) => {
      cells[`d${index}`] = dayCell((data.average.cells || [])[index]);
    });
    totals = { label: data.average.label || 'Weighted average', cells };
  }
  const asOf = data.asOf ? `As of ${data.asOf}` : '';
  return renderDataTable({
    type: 'cohort',
    id: block && block.id,
    title: data.title || 'Cohort',
    columns,
    rows,
    totals,
    sortable: data.sortable === true,
    note: asOf,
    truncated: data.truncated,
    shown: data.shown,
    actions,
    askTitle: data.title || 'Cohort',
  });
}
